export interface NotificationCenterResource {
    uuid: string
    action: string
    category: string
    tags: string[]
    currentUserName: string
}

export interface NotificationCenterLog {
    uuid: string
    action: string
    category: string
    tags: string[]
    currentUserName: string
}

// Update this enum from /api/v3/event-logs/categories if needed
export enum NotificationCenterCategory {
    ABSENCE = 'verzuim',
    AGNOSTIC = 'agnostic',
    CUSTOM = 'custom',
    DATA_UPDATE = 'data-update',
    EMAIL = 'email',
    ENTITY = 'entity',
    EXCHANGE = 'exchange',
    LEAVE_OF_ABSENCE = 'verlof',
    SHIFT = 'dienst',
    SHIFT_EXCHANGE = 'shift-exchange',
    SHIFT_PLANNING = 'dienstplanning',
    SHIFT_PLANNING_REMOVAL = 'dienstplanningremoval',
    TRACKS = 'tracks',
    UNKNOWN = 'unknown',
    USER = 'gebruiker',
}

// Update this enum from /api/v3/event-logs/actions if needed
export enum NotificationCenterAction {
    AGNOSTIC = 'agnostic',
    CREATED = 'created',
    DELETED = 'deleted',
    GENERATE = 'generate',
    NOTIFICATION = 'notification',
    UNKNOWN = 'unknown',
    UPDATED = 'updated',
}

// Update this enum from /api/v3/event-logs/tags if needed
export enum NotificationCenterActionCategory {
    CONCEPT_SHIFT_CREATED = 'concept-dienst-aangemaakt',
    EXCHANGE_CREATED = 'open-ruilvoorstel-aangemaakt',
    EXCHANGE_CANCELLED = 'open-ruilvoorstel-geannuleerd',
    EXCHANGE_APPROVED = 'open-ruilvoorstel-goedgekeurd',
    EXCHANGE_DECLINED = 'open-ruilvoorstel-afgewezen',
    EXCHANGE_UPDATED = 'open-ruilvoorstel-gewijzigd',
    SHIFT_CREATED = 'dienst-aangemaakt',
    SHIFT_DELETED = 'dienst-verwijderd',
    SHIFT_UPDATED = 'dienst-gewijzigd',
    SHIFT_EXCHANGE_CREATED = 'ruildienst-aangemaakt',
    SHIFT_EXCHANGE_CANCELLED = 'ruildienst-geannuleerd',
    SHIFT_EXCHANGE_APPROVED = 'ruildienst-goedgekeurd',
    SHIFT_EXCHANGE_DECLINED = 'ruildienst-afgewezen',
    SHIFT_EXCHANGE_UPDATED = 'ruildienst-gewijzigd',
    SHIFT_PLANNING_CREATED = 'dienstplanning-aangemaakt',
    SHIFT_PLANNING_REGISTERED = 'dienstplanning-aangemeld',
    SHIFT_PLANNING_REGISTRATION_ACCEPTED = 'dienstplanning-aanmelding-geaccepteerd',
    SHIFT_PLANNING_REGISTRATION_DELETED = 'dienstplanning-aanmelding-verwijderd',
    SHIFT_PLANNING_REGISTRATION_CANCELLED = 'dienstplanning-aanmelding-geannuleerd',
    SHIFT_PLANNING_UPDATED = 'dienstplanning-gewijzigd',
    USER_ACTIVATED_BY_EMPLOYEE = 'gebruiker-geactiveerd-door-medewerker',
    SOURCE_EMPLOYEE_APP = 'vanuit-medewerkers-app',
    UNKNOWN = 'unknown',
}

export enum NotificationCenterHeaderName {
    X_EVENT = 'x-event',
}
